<div *ngIf="update" class="flex items-center" [ngClass]="'text-' + update.color + '-500'">
  <div
    *ngIf="update.icon; let icon"
    class="mr-1"
    [ngClass]="'fill-' + update.color + '-500'"
    [inlineSVG]="'/assets/icons/24/' + icon + '.svg'"
  ></div>
  {{ update.label | translate }}
</div>
